import { clsx } from 'clsx'
import type { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { Typography } from '@/src/elements/text/Typography'

import type { TChatMessageProps } from '../ChatMessage.types'
import { ChatMessageBubble } from '../ChatMessageBubble'

export type TChatMessageDeletedProps = Pick<TChatMessageProps, 'firstOfBatch' | 'isSender' | 'lastOfBatch'>

export const ChatMessageDeleted = ({ firstOfBatch, isSender, lastOfBatch }: TChatMessageDeletedProps): ReactNode => (
  <ChatMessageBubble
    firstOfBatch={firstOfBatch}
    isSender={isSender}
    lastOfBatch={lastOfBatch}
    className={clsx('px-4 py-2', isSender ? 'bg-secondary-bg-inverse' : 'bg-white')}
  >
    <Typography italic colors={isSender ? 'white' : 'default'} className="opacity-60">
      <FormattedMessage id="message.deleted" />
    </Typography>
  </ChatMessageBubble>
)
